import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TelemedicineService } from '../../services/telemedicine.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';

@Component({
    selector: 'app-end-call-message',
    templateUrl: './end-call-message.component.html',
    styleUrls: ['./end-call-message.component.scss'],
    standalone: false
})
export class EndCallMessageComponent implements OnInit {

  constructor(
    private modal: BsModalRef,
    public t: TelemedicineService,
    private auth: AuthenticationService
  ) { }

  ngOnInit() {
    
  }

  rejoin() {
    this.t.hasMessage(true)
    this.modal.hide()

  }

  endCall() {
    this.t.hasMessage(false)
    this.modal.hide()
  }

}
